import { render, staticRenderFns } from "./AdminUsers.vue?vue&type=template&id=37e8971e&scoped=true&"
import script from "./AdminUsers.vue?vue&type=script&lang=ts&"
export * from "./AdminUsers.vue?vue&type=script&lang=ts&"
import style0 from "./AdminUsers.vue?vue&type=style&index=0&id=37e8971e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e8971e",
  null
  
)

export default component.exports
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QToggle,QBtn,QDialog,QCard,QCardSection,QSpace,QInput,QPagination,QScrollArea});qInstall(component, 'directives', {ClosePopup});
